import { createContext, useContext } from 'react';

export interface MainMenuContextValue {
  openSection: string | null;
  setOpenSection: (id: string | null) => void;
  collapsed: boolean;
}

export const MainMenuContext = createContext<MainMenuContextValue>({
  openSection: null,
  setOpenSection: () => {},
  collapsed: false,
});

export function useMainMenuContext(): MainMenuContextValue {
  return useContext(MainMenuContext);
}
